import { render } from "./CartOffersCouponCodesTab.vue?vue&type=template&id=1b50d4c9"
import script from "./CartOffersCouponCodesTab.vue?vue&type=script&lang=js"
export * from "./CartOffersCouponCodesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__